<script>
	import { Link } from 'svelte-routing';
	import { cartStore } from '../../stores/cart.store';
	const currentPath = window.location.pathname;
</script>

<header class="header" id="header">
	<div class="navigation">
		<div class="nav-center container d-flex">
			<div class="logo">
				<img src="images/skateboard-logo.jpg" alt="" />
				<Link to="/"><h3>SKIING</h3></Link>
			</div>

			<ul class="nav-list d-flex">
				<li class="nav-item">
					<Link to="/" class="nav-link">HJEM</Link>
				</li>
				<li class="nav-item">
					<Link to="/products" class="nav-link">SNOWBOARDS</Link>
				</li>
				<li class="nav-item">
					<Link to="/product-details" class="nav-link">SNOWBOARDSBAG</Link>
				</li>
				<li class="nav-item">
					<Link to="" class="">VINTERSTED</Link>
					<ul>
						<li>
							<a target="_blank" href="https://www.skiarlberg.at/en">ARLBERG</a>
						</li>

						<li>
							<a target="_blank" href="https://www.ischgl.com/en">ISCHGL</a>
						</li>
						<li>
							<a target="_blank" href="https://www.stmoritz.com/en">ST.MORITZ</a
							>
						</li>
						<li>
							<a target="_blank" href="https://en.tignes.net/">TIGNES</a>
						</li>
						<li>
							<Link to="/videos">SNOWBOARDING TUTORIA</Link>
						</li>
					</ul>
				</li>
				<li class="nav-item">
					<Link to="/contact" class="nav-link">KONTAKT</Link>
				</li>
			</ul>

			<div class="icons d-flex">
				<Link to="/cart" class="icon">
					<i class="bx bx-cart" />
					<span class="d-flex">
						{$cartStore.reduce((acc, item) => acc + item.quantity, 0)}
					</span></Link
				>
			</div>

			<div class="hamburger">
				<i class="bx bx-menu-alt-left" />
			</div>
		</div>
	</div>
</header>
<div style="height: 60px;" />

<style>
	/* your styles go here */
	.logo {
		width: 50px;
		height: 50px;
		display: flex;
		align-items: center;
		margin-right: 160px;
	}
	.logo img {
		width: 100%;
		height: 100%;
	}
</style>
